import React from 'react';
import HttpStatusPage from 'app/components/pages/HttpStatusPage';
import { useI18n } from 'app/components/localization';

export const Maintenance: React.FC = () => {
  const { t } = useI18n();
  return (
    <HttpStatusPage
      status={503}
      header={t('http-status-page.503.header')}
      message={t('http-status-page.503.message')}
    />
  );
};

export default Maintenance;
